import type { Worker, MessagePort } from 'worker_threads'
import { IAdapter } from './interface'
import { TestWorkerMessageType } from '../sandbox/test-sandbox/messageType'

export const createWorkerThreadAdapter = (worker: Worker): IAdapter => {
	return {
		registerPort: ({ remotePort }) => {
			worker.postMessage({ type: TestWorkerMessageType.RegisterRemoteUiPort, data: remotePort }, [
				(remotePort as unknown) as MessagePort,
			])
		},
	}
}
